export * from './compare-programs/compare-programs.component';
export * from './portfolio/portfolio.component';
export * from './about/about.component';
export * from './contact/contact.component';
export * from './home/home.component';